var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},[_c('label',{domProps:{"textContent":_vm._s(_vm.label)}}),_vm._t("default"),(_vm.error)?_c('p',{staticClass:"error-message",domProps:{"innerHTML":_vm._s(_vm.error)}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }